import React, { createContext, useState, useEffect } from 'react';
import styled,{keyframes} from 'styled-components'
import ProgressDial from "new_components/molecules/ProgressDial";

const AICard = ({ start, alreadyRun, currentMsg = null }) => {
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (!alreadyRun) {
      setTimeout(() => {
        start();
      }, 3000);
    } else {
      setFinished(true);
    }
  }, [alreadyRun]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
        marginTop: 20,
      }}
    >
      <Card>
        {!finished ? (
          <>
            <Title>{currentMsg || "Running risk analysis"}</Title>
            <ProgressDial infinite size="20px" />
          </>
        ) : (
          <CompletedCol>
            <Title>
              {(currentMsg && "Completed Thematic Analysis") ||
                "Completed Assessment"}
            </Title>
            {currentMsg && !finished && (
              <Description>
                *This may take several minutes to complete
              </Description>
            )}
          </CompletedCol>
        )}
      </Card>
    </div>
  );
};

export default AICard;

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const Card = styled.div`
  padding: 20px;
  border-radius: 10px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0;
  animation: ${fadeIn} 0.5s forwards;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-family: "Raleway", sans-serif;
  margin-right: 8px;

  opacity: 0;
  animation: ${fadeIn} 0.5s forwards;
`;

const CompletedCol = styled.div`
  display: flex;
  flex-direction: column;
`;

const Description = styled.div`
  font-size: 10px;
  font-weight: 300;
`;
